var typo = require('ru-typo/build/bundle.js');

$(function () {
    $('.js_typo').each(function (idx, el) {
        el.innerHTML = typo(el.innerHTML, {
            digits: true,
            digitsR: true
        });
    });
});